import {catchError, finalize, flatMap, map, switchMap, take, tap} from 'rxjs/operators';
import {defineDefaultBlueTheme} from '../../shared/utils/monacoEditorUtils/monaco-editor-config';
import {
    AfterViewInit,
    Component,
    DoCheck,
    ElementRef,
    OnDestroy,
    OnInit,
    TemplateRef,
    ViewChild,
    ViewContainerRef,
} from '@angular/core';
import {nodeEmitter, stepLocation} from './services/flowBuilder/utils/locaction-calculator-interface';
import {Step} from '../../shared/models';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpErrorResponse} from '@angular/common/http';
import {FlowManagerService} from './services/flow-manager.service';
import {
    Environment,
    Flow,
    FlowMetaData,
    SharedService,
} from '../../core/services/store/shared-store/shared-storage.service';
import {reset} from './services/flowBuilder/utils/constants';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {menuTypes} from './components/json-to-from/types/menu/menu';
import {actionTypes} from './components/json-to-from/types/actions/action';
import {combineLatest, forkJoin, Observable, of, Subscription, throwError} from 'rxjs';
import {StageRequest, SubmissionRequest} from '../../shared/models/flow-manager-core';
import {swalMini, swalWarningTop} from '../../shared/utils/utils';
import {ZoomService} from './services/flowBuilder/zoom.service';
import {FlowBuilderService} from './services/flowBuilder/flow-builder.service';

import {NodeEmitter, OnEnterEvent} from './components/flow-node/flow-node.component';

import cloneDeep from 'lodash/cloneDeep';
import assign from 'lodash/assign';
import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import remove from 'lodash/remove';

import {FlowWebSocketsService} from './services/flowBuilder/flow-web-sockets.service';
import {integration} from './components/json-to-from/types/integration/integration';
import {ActiveFormService} from './services/active-form.service';
import {UserStoreService} from '../../core/services/store/UserStore/user-store.service';
import {MatMenu, MatMenuContent, MatMenuItem, MatMenuTrigger} from '@angular/material/menu';
import {ToastBannerService} from '../../shared/components/cms/toast-banner/toast-banner.service';
import {DeleteStepData} from './services/flowBuilder/models';
import {KeyEventsService} from './services/flowBuilder/key-events.service';
import {SubmissionService} from '../../core/services/management/submission/submission.service';
import {RolesService} from '../../core/services/roles/roles.service';
import {
    completeDeployModalAction,
    confirmationModalCloseState,
    confirmationModalOpenState,
    getEntityConfig,
    oneClickDeployConfirmationModalAction,
    oneClickDeployModalAction,
    selectActionNodeTypes,
    selectChatHubNodesTypes,
    selectIntegrationsNodeTypes,
    selectMenuNodeTypes,
    selectModalDeployState,
    selectModalState,
    selectNodeTypes,
} from '../../core';
import {IntegrationsNodes, NodeObject} from '../../shared/utils/nodeTypes';
import {flowMetaDataAction, flowModeAction} from '../../core/state/actions/flow.action';
import {select, Store} from '@ngrx/store';
import {ManagementService} from '../../core/services/management/management.service';
import {StateService} from '../../core/services/store/state/state.service';
import {FlowDrawerComponent} from './components/flow-drawer/flow-drawer.component';
import {FlowDeployState, FlowModeState, FlowType} from '../../shared/models/state/Flow';
import {
    ConfirmBtnEnum,
    ConfirmModalConfig,
    SubmissionsApprovalRequestConfig,
} from '../../shared/models/confirmModalConfig';
import {ConfirmationPopupComponent} from '../../shared/components/confirmation-popup/confirmation-popup.component';
import {BotModalComponent} from './components/bots/bot-modal/bot-modal.component';
import {
    SaveToExistingBotModalComponent,
} from './components/bots/save-to-existing-bot-modal/save-to-existing-bot-modal.component';
import {ManagePlaceholderComponent} from './components/bots/manage-placeholder/manage-placeholder.component';
import {
    LeftSearchBarComponent,
    MatchClickEvent,
    ReplaceStep,
} from './components/left-search-bar/left-search-bar.component';
import {HighLightAndScrollTo} from './services/flowBuilder/findAndReplace/HighLightAndScrollTo';
import {ReplaceAllSteps} from './services/flowBuilder/findAndReplace/FindAndReplace';
import {MediaCopyRequest, MediaCopyResponse} from '../../shared/models/media-copy-request.model';
import {AsyncPipe, NgClass, NgStyle} from '@angular/common';
import {MatTooltip} from '@angular/material/tooltip';
import {LoadingIconComponent} from '../../shared/components/loading-icon/loading-icon.component';
import {RecycleBinComponent} from './components/recycle-bin/recycle-bin.component';
import {LogsComponent} from './components/logs/logs.component';
import {RightSidebarComponent} from './components/right-sidebar/right-sidebar.component';
import {MatDivider} from '@angular/material/divider';
import {MatIcon} from '@angular/material/icon';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SavingInProgressComponent} from '../../shared/components/saving-in-progress/saving-in-progress.component';
import {FlowSummarySidebarComponent} from './components/flow-summary-sidebar/flow-summary-sidebar.component';
import {MonacoEditorModule} from '@materia-ui/ngx-monaco-editor';
import {LeftSidebarComponent} from "../../core/components/left-sidebar/left-sidebar.component";
import {FlowStepSelectionComponent} from "./components/flow-step-selection/flow-step-selection.component";

const MENUS = menuTypes;
const ACTIONS = actionTypes;
const INTEGRATION = integration;

@Component({
    selector: 'app-flow',
    templateUrl: './flow.component.html',
    styleUrls: ['./flow.component.scss'],
    providers: [ActiveFormService],
    imports: [NgClass, MatTooltip, NgStyle, FlowDrawerComponent, LoadingIconComponent, RecycleBinComponent, LogsComponent, MatMenuTrigger, RightSidebarComponent, MatMenu, MatMenuItem, MatDivider, MatIcon, ReactiveFormsModule, FormsModule, MatMenuContent, SavingInProgressComponent, ConfirmationPopupComponent, LeftSearchBarComponent, FlowSummarySidebarComponent, AsyncPipe, MonacoEditorModule, LeftSidebarComponent, FlowStepSelectionComponent]
})
export class FlowComponent implements OnInit, OnDestroy, DoCheck, AfterViewInit {
    monacoOptions = {
        theme: 'defaultBlueTheme',
        language: 'json',
        automaticLayout: true,
        minimap: {
            enabled: false
        },
        scrollBeyondLastLine: false,
        lineNumbers: 'on',
        renderLineHighlight: 'all',
        contextmenu: true,
        scrollbar: {
            vertical: 'visible',
            horizontal: 'visible'
        }
    };

    showTemplateModal = false;
    systemLibraryFlows: any[] = [];
    private permittedMenu: string[] = [];
    private permittedAction: string[] = [];
    private permittedIntegration: string[] = [];
    private permittedChatHub: string[] = [];
    private permittedNodes: string[] = [];
    public templateMode = false;
    private _flowBeforeTemplate: any;
    pendingSelection = '';
    pendingSelectionStep = '';
    private isImportingTemplate = false;

    constructor(
        private route: ActivatedRoute,
        protected flowManagerService: FlowManagerService,
        public sharedService: SharedService,
        private router: Router,
        public dialog: MatDialog,
        public zoomService: ZoomService,
        public flowBuilderService: FlowBuilderService,
        private submissionService: SubmissionService,
        private rolesService: RolesService,
        public flowWebSocket: FlowWebSocketsService,
        public activeFormService: ActiveFormService,
        public userStore: UserStoreService,
        private toastService: ToastBannerService,
        private keyEventsService: KeyEventsService,
        private managementService: ManagementService,
        private store: Store,
        private stateService: StateService,
    ) {
        this.router.routeReuseStrategy.shouldReuseRoute = function () {
            return false;
        };
    }

    private onNodeEvent: OnEnterEvent;
    private nodeClickedEvent: NodeEmitter;
    private routeParams: Subscription;
    public displayApprovalButton: Boolean = true;
    public displayPreviewButton: Boolean = false;
    selectedMenuData;
    public hasChatHubData = false;
    public chatHubData: NodeObject[];
    private chatHubNodes$: Subscription;
    public showCodeView = false;
    public codeText = '';
    public isCodeModified = false;
    private originalCodeText = '';
    currentFlowType: FlowType;
    flow: any;
    stepData: string | Step | nodeEmitter;
    setSideBar: string;
    searchForStep: string;
    selectedNode: string;
    submitForApprovalMessage = '';
    requestFlowLoad = '';
    requestRouteLoad = '';
    zoomDisplay: number;
    isScrollZoom = false;
    isNewNodeAdded = false;
    nodeTypes: any = assign({}, cloneDeep(MENUS), cloneDeep(ACTIONS), cloneDeep(INTEGRATION));
    deletedSteps: {};
    currentFlowSteps: string[] = [];
    @ViewChild(MatMenuTrigger)
    zoomMenu: MatMenuTrigger;
    displayFlowSummaryButton = true;
    isFlowSummarySidebarVisible = false;
    canShowFlowSummary = false;

    @ViewChild('flowComponent', {static: true}) flowComponent: ElementRef;

    @ViewChild('alertDialog', {static: true}) alertDialog: TemplateRef<any>;
    public alertTitle = '';
    public alertText = '';

    // flowId: string;
    flowTitle: any;
    // flowPath: string;
    newFlowName = '';

    clientId: string;
    env: string;

    requestNodeSaved: any;

    recycleBinClearNodesDialogRef;
    menuNodeTypes: Observable<NodeObject[]>;
    actionNodeTypes: Observable<NodeObject[]>;
    integrationsNodeTypes: Observable<NodeObject[]>;
    globalEnvironment: Environment;
    saveFlowStatus: Boolean = true;
    nextPage: string = null;
    activeFlowPath = '';
    isNewNode: Boolean = false;
    isRecycleBin = false;
    selectNode: string;
    savingInProgress: Boolean = false;
    settingsAndShortcutsDialogRef;
    searchValue: String = '';
    flowStatus: String = null;
    activeMode: string;
    entityConfig: any = null;

    isRecycleBinItem = false;
    logsOpen = false;
    entityConfig$: Observable<any>;
    isSingleApprover: boolean;
    tooltipText = '';

    private isFlowLocked: boolean = this.flowWebSocket.isFlowLocked(this.sharedService.getFlowRef);

    @ViewChild('saveNewFlowDialog', {static: true}) saveNewFlowDialog: TemplateRef<any>;
    @ViewChild('saveExistingFlowDialog', {static: true}) saveExistingFlowDialog: TemplateRef<any>;
    @ViewChild('submitForApprovalDialog', {static: true}) submitForApprovalDialog: TemplateRef<any>;
    @ViewChild('resetFlowDialog', {static: true}) resetFlowDialog: TemplateRef<any>;
    @ViewChild('newNodeDialog', {static: true}) newNodeDialog: TemplateRef<any>;
    @ViewChild('settingsAndShortcutsDialog', {static: true}) settingsAndShortcutsDialog: TemplateRef<any>;
    @ViewChild('recycleBinClearNodesDialog', {static: true}) recycleBinClearNodesDialog: TemplateRef<any>;
    @ViewChild('addNextNode', {static: true}) addNextNode: TemplateRef<any>;
    @ViewChild('flowDrawer') flowDrawer: FlowDrawerComponent;
    @ViewChild('findAndReplace') findAndReplace: LeftSearchBarComponent;

    @ViewChild('viewcontainer', {'read': ViewContainerRef, static: true}) viewcontainer!: ViewContainerRef;
    @ViewChild(TemplateRef, {static: true}) template!: TemplateRef<null>;
    state: boolean;
    state$ = this.store.select(selectModalState);
    deployState: { type?: FlowDeployState, actionDeploy: boolean };
    deployState$ = this.store.select(selectModalDeployState);
    tempEventAddNode = {};
    tempParentId: string;
    private areaWidth: number;
    private areaHeight: number;

    highLightAndScrollTo: HighLightAndScrollTo = undefined;
    protected readonly FlowType = FlowType;
    excludedNodeTypes = ['nestedNode', 'nested', 'async_api'];
    isUserInternal: boolean;
    hasClickatellAiFlag = false;
    allowedEntityFacingNodes: boolean;

    ngOnInit() {
        try {
            defineDefaultBlueTheme();
        } catch (e) {
        }

        this.currentFlowType = this.stateService.getFlowMetaData()?.flowType;

        this.displayApprovalButton = this.sharedService.getEntityType() !== 'TEMPLATE';
        this.displayPreviewButton = this.sharedService.getEntityType() !== 'FUNDING_SOURCE' && this.sharedService.getEntityType() !== 'VENDOR';
        this.flow = this.flowBuilderService.getFlow();

        this.activeMode = FlowModeState.FLOW_MODE;

        this.isUserInternal = this.isInternalUser();
        this.allowedEntityFacingNodes = this.isAllowedEntityFacingNodes();

        this.entityConfig$ = this.store.pipe(
            select(getEntityConfig),
            tap(data => {
                if (data['single-approver'] && this.isInternalUser()) {
                    this.tooltipText = '1-Click Deploy active, only clients can deploy';
                } else if ((!data['single-approver'] && this.isInternalUser()) || (data['single-approver'] && !this.isInternalUser())) {
                    this.tooltipText = '';
                }
                this.isSingleApprover = data['single-approver'];
            })
        );

    this.entityConfig$.pipe(map(state => state)).subscribe((currentState) => this.entityConfig = currentState);
    this.menuNodeTypes = this.store.select(selectMenuNodeTypes).pipe(
      map((nodes) => {
        const nodesArr = [...nodes];
        remove(nodesArr, ({nodeType}) => (nodeType === 'payment'));
        return nodesArr;
      })
    );
    this.actionNodeTypes = this.store.select(selectActionNodeTypes);
    this.chatHubNodes$ = this.store.select(selectChatHubNodesTypes).subscribe(
      (data) => {
        this.hasChatHubData = !isEmpty(data);
        this.chatHubData = data;
      }
    );
    this.integrationsNodeTypes = this.store.select(selectIntegrationsNodeTypes).pipe(map((nodes: IntegrationsNodes) => {
      if (!this.isUserInternal) {
        const excludedNodeTypes = ['nestedNode', 'nested', 'async_api'];
        return nodes['default'].filter((node: NodeObject) => !excludedNodeTypes.includes(node.nodeType));
      }
      if (this.sharedService.getEntityType() === 'VENDOR' || this.sharedService.getEntityType() === 'FUNDING_SOURCE') {
        const nodeToReturn = nodes[this.sharedService.getEntityType()].filter((node: NodeObject) => node.nodeType === this.sharedService.getFlowName);
        if (nodeToReturn.length) {
          return nodeToReturn.concat(nodes.default);
        }
      }
      return nodes.default;
    }));

        this.managementService.getEntityConfigs().subscribe(config => {
            this.hasClickatellAiFlag = !!config['clickatell-ai'];
        });

        this.flowManagerService.getSystemFlows(this.isUserInternal).subscribe((systemFlows) => {
            this.systemLibraryFlows = systemFlows;
        });

        this.route.queryParams.subscribe(params => {
            if (params.openTemplate) {
                this.openTemplateModal();
            }
        });

        this.isUserInternal = this.rolesService.isUserInternal();
    }

    openExistingBotModal(botName?: string, templateName?: string) {
        if (this.sharedService.getEntityType() === 'TEMPLATE') {
            this.dialog.open(SaveToExistingBotModalComponent, {
                panelClass: 'saveNewFlowDialog',
                width: '442px',
                height: '355px',
                disableClose: false,
                data: {
                    isEditMode: false,
                    flow: this.flowBuilderService.getFlow()
                }
            });
        }
    }

    isInternalUser(): boolean {
        return this.rolesService.isUserInternal();
    }

    isAllowedEntityFacingNodes(): boolean {
        this.allowedEntityFacingNodes = this.currentFlowType !== FlowType.ApiFlow && (
            this.sharedService.getEntityType().toUpperCase() === 'CLIENT' ||
            this.sharedService.getEntityType().toUpperCase() === 'SYSTEM' &&
            this.sharedService.getEntityId() === '1'
        );
        return this.allowedEntityFacingNodes;
    }

    setActiveState(flowModeState) {
        this.activeMode = flowModeState;
        if (this.flowDrawer) {
            this.flowDrawer.activeMode = flowModeState;
        }
    }

    setArea() {
        const area = document.getElementById('drawArea') as HTMLDivElement;
        if (area) {
            this.flowBuilderService.setFlowArea = area;
            this.zoomService.setPanZoomInstance = area;
            const zoomType = this.userStore.getZoomPreference;
            this.zoomService.setZoomType(zoomType);
            this.isScrollZoom = zoomType === 'panZoom';
        }

        if (this.route.params) {
            this.routeParams = this.route.params.subscribe((params) => {
                if (this.isImportingTemplate) {
                    return;
                }
                this.reset();
                if (
                    this.isReloadRequired(params) ||
                    params['flowPath'] !== this.sharedService.getFlowPathName()
                ) {
                    this.loadFlow(params['env'], params['entityId'], params['flowPath']);
                }
                this.activeFlowPath = params['flowPath'];
            });
        }
    }

    ngAfterViewInit() {
        this.sharedService.requestEnvironment = {...this.sharedService.globalEnvironment};

        this.setCenterOnCanvas('dragArea', 'drawArea', 2, 2);
        this.setAreaCenterPosition();
        setTimeout(() => this.setArea(), 0);

        // this.requestNodeSaved = this.sharedService.isNodeSaved$.subscribe((data) => {
        //     if (data === true) {
        //         this.showSaveDialog();
        //     }
        //     if (data === false) {
        //         this.flowBuilderService.resetFlow();
        //         this.newFlow();
        //     }
        // });

        if (this.flowComponent) {
            this.keyEventsService.setKeyFunctionality(
                this.flowComponent.nativeElement,
                'dragArea',
                'drawArea',
                this.onNodeEvent,
                'searchForStep'
            );
        }
    }

    setAreaCenterPosition() {
        setTimeout(() => {
            const dragArea = document.getElementById('dragArea');
            if (!dragArea) return;
            const observer = new ResizeObserver(entries => {
                const drawArea: HTMLElement = document.getElementById('drawArea');
                if (!drawArea) return;
                if (this.activeMode === FlowModeState.PREVIEW_MODE) {
                    for (const entry of entries) {
                        this.areaWidth = entry.contentRect.width;
                        this.areaHeight = entry.contentRect.height;
                        drawArea.style.translate = `${this.areaWidth / 2}px ${this.areaHeight / 2}px`;
                    }
                } else {
                    drawArea.style.translate = '0px 0px';
                }
            });
            observer.observe(dragArea);
            this.resizeObservers.push(observer);
        }, 1000);
    }

    copyFlowCallback() {
        if (this.onNodeEvent) {
            if (!(this.onNodeEvent?.stepId && this.onNodeEvent?.parentId) || (this.onNodeEvent.stepType === 'new' || this.onNodeEvent.stepType === 'start')) {
                return;
            }
            this.flowBuilderService.copy(
                this.onNodeEvent.stepId,
                this.onNodeEvent.parentId
            );
            swalMini({
                title: `${this.onNodeEvent.stepId} copied`,
                type: 'success',
            });
        }
    }

    /**
     * The function deployToProduction() is called when the user clicks the "Deploy to Production"
     * button. The function deployToProduction() dispatches the action clickDeployState() to
     * the store. The function deployToProduction() then calls the function onClose() which closes the
     * modal.
     */
    clickDeployToProduction() {
        this.store.dispatch(oneClickDeployModalAction({payload: this.getSubmissionApprovalRequestPayload()}));
        setTimeout(() => {
            this.onClose();
        }, 500);
    }

    pasteFlowCallback() {
        if (this.flowBuilderService.getOperationState && this.flowBuilderService.getOperationState.operationType && this.onNodeEvent.stepType === 'new') {
            this.flowBuilderService.paste(this.onNodeEvent.stepId, this.onNodeEvent.parentId);
        } else {
            swalWarningTop('Hover over an empty node to paste node.');
        }
    }

    private resizeObservers: ResizeObserver[] = [];

    ngOnDestroy(): void {
        if (this.requestNodeSaved) {
            this.requestNodeSaved.unsubscribe();
        }

        this.keyEventsService.unsubscribeKeyEventsSubscriptions();

        this.sharedService.setFlowRef = '';
        this.sharedService.setFlowPathName('');
        this.sharedService.setFlowName = '';

        if (this.chatHubNodes$) {
            this.chatHubNodes$.unsubscribe();
        }
        this.resizeObservers.forEach(observer => {
            observer.disconnect();
        });
        this.resizeObservers = [];
    }

    /**
     * If the state is true, then close the modal.
     */
    ngDoCheck(): void {
        this.reloadFlowAfterUnlock();

        this.state$.pipe(map(state => state)).subscribe((currentState) => this.state = currentState);
        if (this.state) {
            this.onClose();
        }

        this.deployState$.pipe(map(state => state)).subscribe((currentState) => this.deployState = currentState);
        if (this.deployState.actionDeploy && this.deployState.type === FlowDeployState.CLICK_DEPLOY) {
            this.clickDeployToProduction();
            this.store.dispatch(completeDeployModalAction({completed: true}));
        }

        this.currentFlowType = this.stateService.getFlowMetaData()?.flowType;
    }

    /**
     * The function removes the view container from the DOM
     */
    onClose() {
        this.viewcontainer.remove();
    }

    /**
     * If the user is internal, return 'INTERNAL', otherwise return 'CLIENT'
     * @returns The role of the user.
     */
    getRole(): string {
        if (this.sharedService.getEntityType() === 'SYSTEM' && this.rolesService.isTemplateUser()) {
            return 'SYSTEM';
        }

        return this.rolesService.isUserInternal() ? 'INTERNAL' : 'CLIENT';
    }

    displayOnTemplate() {
        return this.sharedService.getEntityType() === 'TEMPLATE';
    }


    /**
     * It returns a payload object that contains the submissionId, reviewerType, submissionType, flowId,
     * flowPath, and action
     */
    getSubmissionApprovalRequestPayload(): SubmissionsApprovalRequestConfig {
        return {
            flowName: this.sharedService.getFlowName,
            env: 'dev',
            submissionsApprovalRequest: {
                submissionId: 0,
                reviewerType: this.getRole(),
                submissionType: 'PROMOTE',
                flowId: this.sharedService.getFlowRef,
                flowPath: this.sharedService.getFlowNameToPath.replace(',', '/'),
                action: 'DEPLOY'
            }
        };
    }

    /**
     * It creates a payload object, which is used to send a request to the server, and a config object,
     * which is used to configure the modal
     */
    createConfirmConfig() {
        const payload: SubmissionsApprovalRequestConfig = this.getSubmissionApprovalRequestPayload();
        const config: ConfirmModalConfig = {
            modalState: false,
            title: 'Deploy to Production',
            body: 'Do you want to deploy this workflow to production? The flow will be live shortly.',
            button: {
                'primary': {
                    name: 'Deploy',
                    activeName: 'Deploying',
                    style: ConfirmBtnEnum.primary
                },
                'secondary': {
                    name: 'Cancel'
                }
            }
            ,
            callBackType: {
                'primary': oneClickDeployConfirmationModalAction({payload: payload}),
                'secondary': confirmationModalCloseState()
            },
            deployState: {actionDeploy: false}
        };

        this.store.dispatch(confirmationModalOpenState({config}));
    }

    private reloadFlowAfterUnlock(): void {
        if (this.isFlowLocked !== this.flowWebSocket.isFlowLocked(this.sharedService.getFlowRef)) {
            if (this.isFlowLocked && !this.flowWebSocket.isFlowLocked(this.sharedService.getFlowRef)) {
                this.loadFlow(this.env, this.clientId, this.sharedService.getFlowRef);
            }
            this.isFlowLocked = this.flowWebSocket.isFlowLocked(this.sharedService.getFlowRef);
        }
    }

    canEditFlows(): boolean {
        if (this.sharedService.getEnvironment() === 'prod') {
            return false;
        }
        return this.rolesService.canEditFlows();
    }

    canEditMenuTextOnly(): boolean {
        if (this.sharedService.getEnvironment() === 'prod') {
            return false;
        }
        return this.rolesService.canEditMenuTextOnly();
    }

    canEdit(): boolean {
        if (this.sharedService.getEnvironment() === 'prod' || this.sharedService.isDeletePending) {
            return false;
        }
        return this.canEditFlows() || this.canEditMenuTextOnly();
    }

    canSubmitForApproval(): boolean {
        return !(this.activeFlowPath === '__NEW_FLOW__' || this.sharedService.getIsFlowChanged())
            && this.sharedService.getFlowStatus !== 'Copied';
    }

    showSaveDialog() {
        if (this.route.params['_value'].flowPath === this.sharedService.getNewFlowName()) {
            this.dialog.open(this.saveNewFlowDialog, {
                panelClass: 'saveNewFlowDialog',
                width: '530px',
                height: '280px',
                disableClose: true,
            });
        } else {
            const path = this.sharedService.flow ? this.sharedService.flow.metaData.directory : '';
            this.sharedService.setFlowPathName(path);

            this.flowTitle = path;
            this.dialog.open(this.saveExistingFlowDialog, {
                panelClass: 'saveExistingFlow',
                width: '530px',
                height: '160px',
                disableClose: true,
            });
        }
    }

    /** TODO JF - 01/07/2020;
     * this does not support Entities
     * this is causing internal users not to load other client flows.
     * look at @# References below  **/
    loadFlow(env: string, clientId: string, flowPath: string) {
        const flowRef = this.extractFlowId(flowPath);

        // Prevent unnecessary reload if we already have the same flow loaded
        if (this.sharedService.getFlowRef === flowRef &&
            this.env === env &&
            this.clientId === clientId &&
            this.sharedService.flow?.metaData?.flowId === flowRef) {
            return;
        }
        this.sharedService.setFlowRef = flowRef;

        this.sharedService.setFlowStatus(flowRef, '');

        if (flowPath !== this.sharedService.getNewFlowName()) {
            this.flowBuilderService.resetFlow();
            this.sharedService.setFlowPathName('');

            // TODO @1 JF - 01/07/2020  need to also change global env (Shard service) also entityType needed
            this.env = env;
            this.clientId = clientId;
            let scrollTo = reset;

            if (flowPath.indexOf(':') !== -1) {
                const flowArray = flowPath.split(':');
                flowPath = flowArray[0];
                scrollTo = flowArray[1];
            }

            const next = (flowId: string, flow: any) => {
                if (flow) {
                    this.codeText = JSON.stringify(flow, null, 2);
                    this.currentFlowSteps = Object.keys(flow);
                    setTimeout(() => {
                        this.checkFlowIssue();
                    }, 1000);
                    this.resetSelectedNode();
                    this.flowBuilderService.buildFlow(flow, this.sharedService.getFlowStatus);
                    this.zoomService.resetZoom();
                }
            };

            const error = (err?: HttpErrorResponse) => {
                let message = 'Unable to load the requested flow. Please try again.';

                if (err?.status === 404) {
                    message = 'The requested flow could not be found. It may have been deleted or moved.';
                } else if (err?.status === 401 || err?.status === 403) {
                    message = 'You do not have permission to view the requested flow.';
                }

                this.sharedService.setFlowRef = '';
                this.canShowFlowSummary = false;
                swalWarningTop(message);
            };

            // Not needed
            // this.getFlowName(flowPath);
            // TODO @2 JF - 01/07/2020; In getFlow it needs to use the updated entities at @1.

            this.flowManagerService.getFlowMetaDataById(flowRef)
                .pipe(
                    take(1),
                    flatMap((val: FlowMetaData) => {
                        this.sharedService.setFlow(new Flow(val, []));
                        this.setFlowData(val.flowName, val.directory, val.flowId, val.flowStatus, val.flowType);
                        if (val.hasOwnProperty('flowStatus')) {
                            this.sharedService.setFlowStatus(flowRef, val.flowStatus);
                            const deletePending = this.sharedService.isDeletePending;
                            if (deletePending) {
                                this.toastService.setBannerParams({
                                    lineColor: '#c23313',
                                    icon: 'delete_thrash_50.svg',
                                    title: 'Request to delete flow “' + val.flowName + '” successfully sent.',
                                    desc: 'Once it has been approved by an admin it will no longer appear in the left bar.',
                                    bigIcon: true,
                                });
                            } else {
                                this.toastService.clearBannerParams();
                            }
                        }
                        return this.flowManagerService.getFlow(flowRef);
                    })
                ).subscribe(
                (flow) => {
                    if (flow && this.sharedService.flow) {
                        this.sharedService.flow.steps = Object.keys(flow).map(stepId => ({id: stepId, ...flow[stepId]}));
                    }
                    next(flowRef, flow);
                },
                (err: HttpErrorResponse) => error(err)
            );
            this.sharedService.setIsFlowChanged(false);
            this.canShowFlowSummary = true;
        } else {
            this.canShowFlowSummary = false;
            this.newFlow();
        }
    }

    setFlowData(name, path, ref, flowStatus, flowType: FlowType) {
        this.sharedService.setFlowRef = ref;
        this.sharedService.setFlowName = name;
        this.sharedService.setFlowPathName(path);
        this.sharedService.setFlowStatus(ref, flowStatus);

        this.updateFlowMetaData(ref, name, path, flowStatus, flowType);
    }

    updateFlowMetaData(flowId: string, flowName: string, directory: string, flowStatus: string, flowType: FlowType) {
        const flowMetaData: FlowMetaData = {
            flowId: flowId,
            flowName: flowName,
            directory: directory,
            flowStatus: flowStatus,
            flowType: flowType
        };

        this.store.dispatch(flowMetaDataAction({flowMetaData}));
        this.currentFlowType = this.stateService.getFlowMetaData()?.flowType;
    }

    getFlowMetaData(flowId, reload, callback) {
        this.flowManagerService.getFlowMetaDataById(flowId).subscribe((value) => {
            callback(value);
        });
    }

    extractFlowId(flowPath: any) {
        const lastIndexOf = flowPath.lastIndexOf(',');
        return lastIndexOf !== -1 ? flowPath.slice(lastIndexOf + 1) : flowPath;
    }

    extractFlowPath(flowPath: any) {
        const lastIndexOf = flowPath.lastIndexOf('/');
        return lastIndexOf !== -1 ? flowPath.slice(0, lastIndexOf) + ',' : '';
    }

    reset() {
        this.flowBuilderService.resetFlow();
        this.resetSelectedNode();
    }

    newFlow() {
        this.reset();
        this.sharedService.setFlowPathName(this.sharedService.getNewFlowName());
        this.flowBuilderService.newFlow();
        this.updateFlowMetaData(null, this.sharedService.getNewFlowName(), null, null, this.stateService.getFlowMetaData()?.flowType);
    }

    resetSelectedNode(action?: string) {
        if (this.canResetNode(action)) {
            this.setSideBar = '';
            this.selectedNode = '';
            this.nodeClickedEvent = null;
        } else {
            const dialogRef = this.dialog.open(this.resetFlowDialog, {
                panelClass: 'resetFlowDialog',
                width: '530px',
                height: '160px',
                disableClose: true,
            });
        }
    }

    canResetNode(action?: string): boolean {
        let canReset = true;
        const form = this.activeFormService.getActiveForm();
        if (form) {
            canReset = !form.dirty;
        }
        return action ? true : canReset;
    }

    resetSelectedNodeWithoutSaving() {
        this.closeModal();
        this.resetSelectedNode('reset');
    }

    showResetNewNodeDialog() {
        const dialogRef = this.dialog.open(this.newNodeDialog, {
            panelClass: 'newNodeDialog',
            width: '530px',
            height: '190px',
            disableClose: true,
        });
    }

    resetNewNodeWithoutSaving() {
        this.closeModal();
    }

    showAddNextNodeDialog() {
        const dialogRef = this.dialog.open(this.addNextNode, {
            panelClass: 'addNextNode',
            width: '530px',
            height: '190px',
            disableClose: true,
        });
    }

    openPreview() {
        this.store.dispatch(flowModeAction({flowModeState: FlowModeState.PREVIEW_MODE}));
        this.setDefaultRightSidebarWidth();
        this.activeMode = this.stateService.getFlowMode();
    }

    toggleScrollZoom() {
        this.zoomService.resetZoom();
        const value = this.isScrollZoom ? 'panZoom' : 'scrollZoom';
        this.zoomService.setZoomType(value);
        this.userStore.setZoomPreference = value;
    }

    addNewNode(nodeType: string, nodeId: string, stepType: string, parentId: string, extraFields: {}, letPass?: boolean) {
        if (
            nodeId === 'start' || parentId === 'start' ||
            (parentId !== 'start' && nodeId !== 'start' && this.activeFormService.getActiveForm() !== null && !this.activeFormService.getActiveForm()['touched']) ||
            (parentId !== 'start' && nodeId !== 'start' && letPass) ||
            !this.isNewNode
        ) {
            if (!this.sharedService.isDeletePending) {
                // this.flowBuilderService.addStep(nodeId, cloneDeep(this.nodeTypes[nodeType].json))
                this.selectedNode = nodeId;
                const node = new NodeEmitter(nodeId, stepType, nodeType, parentId, extraFields);
                this.isNewNode = true;
                this.nodeClick(node, false);
                this.sharedService.isFlowPristine = false;
                this.tempEventAddNode = {};
                if (this.dialog.openDialogs.length) {
                    this.closeModal();
                }
            }
        } else {
            this.tempEventAddNode['nodeType'] = nodeType;
            this.tempEventAddNode['nodeId'] = nodeId;
            this.tempEventAddNode['stepType'] = stepType;
            this.tempEventAddNode['extraFields'] = extraFields;
            this.tempParentId = parentId;
            this.showAddNextNodeDialog();
            this.updateCodeView();
        }
    }

  requestSaveFlow() {
    // Check if in code view and validate JSON before saving
    if (this.showCodeView && !this.validateJsonBeforeSwitch()) {
      return;
    }

    if (
      !this.canSaveFlow() &&
      this.sharedService.getFlowPathName() &&
      this.sharedService.getNewFlowName()
    ) {
      if (this.sharedService.getFlowPathName() === this.sharedService.getNewFlowName()) {
        const dialogRef = this.dialog.open(this.saveNewFlowDialog, {
          panelClass: 'saveNewFlowDialog',
          width: '530px',
          height: '280px',
          disableClose: true,
        });
      } else {
        this.saveFlow();
      }
    }
  }

    showSaveNewBotModal() {
        this.dialog.open(BotModalComponent, {
            backdropClass: 'savetoNewBackdropClass',
            panelClass: 'saveNewFlowDialog',
            width: '713px',
            height: '640px',
            data: {
                isEditMode: false,
                flow: this.flowBuilderService.getFlow(),
            }
        });
    }

    showManagePlaceholderModal() {
        this.dialog.open(ManagePlaceholderComponent, {
            panelClass: 'showManagePlaceholderDialog',
            width: '918px',
            height: '95vh',
            data: this.selectedMenuData
        });
    }

    // TODO: remove usages. Unused
    subscribeToDialogClose(dialogRef: MatDialogRef<any, any>) {
    }

    closeModal() {
        this.sharedService.setRequestRouteLoad('');
        this.sharedService.setRequestFlowLoad('');
        this.globalEnvironment = Object.assign({}, this.sharedService.getGlobalEnvironment());
        this.sharedService.requestEnvironment = Object.assign(
            {},
            this.sharedService.getGlobalEnvironment()
        );
        this.dialog.closeAll();
        // TODO JF: WHY WHY WHY I dont understand why the form needs to be reset after you click cancel!!
        if (this.activeFormService.getActiveForm() !== null) {
            this.activeFormService.removeTouchedForm(this.activeFormService.getActiveForm());
        }
    }

    dontSaveFlow() {
        this.unlockFlow();
        if (this.requestNodeSaved) {
            this.flowBuilderService.resetFlow();
            this.newFlow();
            this.router.navigate([
                'flow',
                this.sharedService.getEnvironment(),
                this.sharedService.getEntityType(),
                this.sharedService.getEntityId(),
                this.sharedService.getNewFlowName(),
            ]);
        }
        this.saveFlowStatus = false;
        this.isNewNode = false;
        this.activeFormService.setIsFormChanged(false);
        this.dialog.closeAll();

        const pendingFlowType = this.sharedService.getPendingFlowType();
        if (pendingFlowType) {
            this.applyPendingFlowType(pendingFlowType);

            this.router.navigate([
                'flow',
                this.sharedService.getEnvironment(),
                this.sharedService.getEntityType(),
                this.sharedService.getEntityId(),
                this.sharedService.getNewFlowName(),
            ]);
            return;
        }

        if (this.nextPage) {
            this.router.navigate([this.nextPage]);
        }
    }

    private applyPendingFlowType(flowType: FlowType) {
        const flowMetaData: FlowMetaData = {
            flowId: '',
            flowName: '',
            directory: '',
            flowStatus: '',
            flowType: flowType
        };

        this.store.dispatch(flowMetaDataAction({flowMetaData}));

        switch (flowType) {
            case FlowType.ApiFlow:
                this.store.dispatch(flowModeAction({flowModeState: FlowModeState.API_FLOW_MODE}));
                break;
            case FlowType.ChatFlow:
            default:
                this.store.dispatch(flowModeAction({flowModeState: FlowModeState.FLOW_MODE}));
                break;
        }

        this.sharedService.clearPendingFlowType();
    }

    checkInvalidSteps() {
        const hasInvalidSteps = this.flowBuilderService.hasInvalidSteps;
        if (hasInvalidSteps.valid) {
            swalMini({
                title: `Validation failed in ${hasInvalidSteps.steps.join(', ')}, please check for errors!`,
                text: '',
                type: 'warning',
            });
            return true;
        }
        return false;
    }

    createFlow(isClearFlow: boolean = false): void {
        const reg: RegExp =
            /^\w[\w'"`!&*()-+=; :<>,.?]*$|^(\w[\w'"`!&*()-+=; :<>,.?]*[\/])+\w[\w'"`!&*()-+=;:<>,.?]*$/;
        const flowPath =
            this.newFlowName === ''
                ? this.sharedService.getFlowPathName()
                : correctName(this.newFlowName);
        const flowName = this.extractFlowId(flowPath);
        const message = '';
        const incorrectName: boolean = flowName.search(reg) === -1 ? true : false;

        if (incorrectName) {
            swalMini({
                title: 'Incorrect flow name!',
                text: '',
                type: 'warning',
            });
            return;
        }
        this.flow = this.flowBuilderService.getFlow();
        this.setStepUniqueID(true);
        const stageFlowRequest: StageRequest = {
            flowId: '',
            flowType: this.stateService.getFlowMetaData().flowType,
            flowName,
            flowPath,
            flow: this.flow,
            message,
        };

        const sameName = this.sharedService.checkSameFlowName('create', {flowPath});
        if (sameName) {
            swalMini({
                title: 'Flow with same name already exist!',
                text: '',
                type: 'warning',
            });
            return;
        }

        if (this.checkInvalidSteps()) {
            return;
        }

        this.savingInProgress = true;
        this.flowManagerService.createFlow(stageFlowRequest).subscribe((response) => {
            if (response.result) {
                swalMini({
                    title: 'Saved successfully!',
                    text: '',
                    type: 'success',
                });
                this.sharedService.setGlobalEnvironment(this.globalEnvironment);
                this.successfullCreateOrUpdate(response.flowMetaData);
                this.dialog.closeAll();
                if (this.activeFormService.getActiveForm() !== null) {
                    this.activeFormService.removeTouchedForm(this.activeFormService.getActiveForm());
                }
                if (this.nextPage) {
                    this.router.navigate([this.nextPage]);
                }
            } else {
                swalMini({
                    title: 'Problem occurred while saving',
                    text: response.message,
                    type: 'warning',
                });
            }
            this.savingInProgress = false;
        }, (response) => {
            swalMini({
                title: response.error.message,
                text: '',
                type: 'warning',
            });
            this.savingInProgress = false;
        });

        function correctName(name: string): string {
            const lastSymbolReg: RegExp = /\/+$/g;
            return name.replace(lastSymbolReg, '');
        }
    }

    saveFlow(isClearFlow: boolean = false): void {
        document.getElementById('saveNode')?.click();
        this.activeFormService.setIsFormChanged(false);
        const flowPath =
            this.newFlowName === '' ? this.sharedService.getFlowPathName() : this.newFlowName;
        const message = '';
        this.flow = this.flowBuilderService.getFlow();
        this.setStepUniqueID(false);
        const stageFlowRequest: StageRequest = {
            flowId: this.sharedService.getFlowRef,
            flowName: this.sharedService.getFlowName,
            flowPath: flowPath,
            flow: this.flow,
            message: message,
        };
        const flowName =
            this.newFlowName === '' ? this.sharedService.getFlowPathName() : this.newFlowName;

        if (this.checkInvalidSteps()) {
            return;
        }

        this.savingInProgress = true;
        this.flowManagerService.saveFlow(stageFlowRequest).subscribe((response) => {
            if (response.result) {
                const flow = this.sharedService.flow;
                if (flow) {
                    this.flowManagerService.generateFlowDescription(flow).subscribe({
                        next: (summary) => {
                            console.log('Flow summary generated successfully:', summary);
                        },
                        error: (error) => {
                            console.warn('Could not generate flow summary:', error);
                        }
                    });
                }

                swalMini({
                    title: 'Saved successfully!',
                    text: '',
                    type: 'success',
                });
                this.unlockFlow();
                if (this.activeFormService.getActiveForm() !== null) {
                    this.activeFormService.removeTouchedForm(this.activeFormService.getActiveForm());
                }
                this.flowManagerService.clearFlowNameCache();
                if (this.requestFlowLoad === 'request') {
                    this.sharedService.setRequestFlowLoad('load');
                } else if (this.sharedService.getRequestRouteLoad() === 'request') {
                    this.sharedService.setRequestRouteLoad('load');
                } else {
                    // this.loadFlow(this.sharedService.getEnvironment(),this.sharedService.getEntityId(),this.sharedService.getFlowName());
                    if (this.newFlowName !== '') {
                        this.sharedService.setFlowPathName(this.newFlowName);
                        this.newFlowName = '';
                        this.closeModal();
                    }
                    const flowPathArr: any = this.sharedService.getFlowPathName().split('/');
                    flowPathArr[flowPathArr.length - 1] = this.sharedService.getFlowRef;
                    this.router.navigate([
                        'flow',
                        this.sharedService.getEnvironment(),
                        this.sharedService.getEntityType(),
                        this.sharedService.getEntityId(),
                        flowPathArr.join(','),
                    ]);
                    this.sharedService.setNewFlowSaved(true);
                }
                this.dialog.closeAll();

                if (isClearFlow) {
                    this.clearFlowArea();
                } else {
                    this.successfullCreateOrUpdate(response.flowMetaData);
                }

                if (this.nextPage) {
                    this.router.navigate([this.nextPage]);
                }
            } else {
                swalMini({
                    title: `Problem occurred while saving (${response.message})`,
                    text: '',
                    type: 'warning',
                });
            }
            this.dialog.closeAll();
            this.sharedService.setGlobalEnvironment(this.globalEnvironment);
            this.savingInProgress = false;
        }, (response) => {
            swalMini({
                title: response.error.message,
                text: '',
                type: 'warning',
            });
            this.savingInProgress = false;
        });
    }

    private setStepUniqueID(isNewFlow: boolean) {
        let isStepUniqueId = false;
        // if existing flow, check for start step has stepUniqueID
        if (!isNewFlow) {
            isStepUniqueId = this.flow['start'].metadata?.stepUniqueID ? true : false;
        }
        if (isNewFlow || isStepUniqueId) {
            for (const step in this.flow) {
                if (this.flow[step].metadata?.stepUniqueID && this.flow[step].metadata?.stepUniqueID !== 'NEW') {
                    continue;
                } else {
                    this.isNewNodeAdded = true;
                    this.flow[step].metadata = {
                        ...this.flow[step].metadata,
                        stepUniqueID: 'NEW'
                    };
                }
            }
        }
    }

    private successfullCreateOrUpdate(flowMetaData) {
        this.unlockFlow();
        this.flowManagerService.clearFlowNameCache();
        if (this.requestFlowLoad === 'request') {
            this.sharedService.setRequestFlowLoad('load');
        } else if (this.sharedService.getRequestRouteLoad() === 'request') {
            this.sharedService.setRequestRouteLoad('load');
        } else {
            // this.loadFlow(this.sharedService.getEnvironment(),this.sharedService.getEntityId(),this.sharedService.getFlowName());
            const path = flowMetaData
                ? flowMetaData.directory
                : this.sharedService.flow.metaData.directory;
            if (this.newFlowName !== '') {
                // @ts-ignore
                this.sharedService.setFlowPathName(path);
                this.newFlowName = '';
                this.closeModal();
            }

            let flowPath = this.extractFlowPath(path).replace(/\//g, ',');
            const flowId = flowMetaData
                ? flowMetaData.flowId
                : this.sharedService.getFlowRef;
            flowPath = flowPath + flowId;
            // @ts-ignore
            this.saveFlowStatus = false;
            this.activeFormService.setIsFormChanged(false);
            this.sharedService.setNewFlowSaved(true);
            const navigationPath = [
                'flow',
                this.sharedService.getEnvironment(),
                this.sharedService.getEntityType(),
                this.sharedService.getEntityId(),
                flowPath,
            ];

            if (this.isNewNodeAdded) {
                this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
                    this.router.navigate(navigationPath);
                });
            } else {
                this.router.navigate(navigationPath);
            }
            this.isNewNodeAdded = false;
        }
    }

    unlockFlow() {
        this.sharedService.setFlowsUpdated(true);
        this.sharedService.setIsFlowChanged(false);
        this.flowWebSocket.unLockFlow();
    }

    lockFlow() {
        if (this.sharedService.getFlowPathName() !== '__NEW_FLOW__') {
            this.sharedService.setFlowsUpdated(true);
            this.flowWebSocket.lockFlow();
        }
    }

    saveNodeClicked(step: Step) {
        this.lockFlow();
        this.flowBuilderService.addStep(this.selectedNode, step);
        this.resetSelectedNode('save');
        this.isNewNode = false;

        if (this.findAndReplace && this.activeMode === FlowModeState.SEARCH_MODE) {
            this.findAndReplace.updateFlow();
        }
    }

    openRecycleBinClearNodesDialog() {
        setTimeout(() => {
            this.recycleBinClearNodesDialogRef = this.dialog.open(this.recycleBinClearNodesDialog, {
                panelClass: 'clickatellDialog',
                width: '442px',
                height: '299px',
                disableClose: true,
            });
        }, 100);
    }

    closeRecycleBinClearNodesDialog(): void {
        this.recycleBinClearNodesDialogRef.close();
        this.selectNode = '';
    }

    clearNodesClick() {
        this.flowBuilderService.clearSteps([this.selectNode]);
        this.sharedService.setIsFlowChanged(true);
        this.resetSelectedNode();
        this.closeRecycleBinClearNodesDialog();
    }

    deleteNodeClicked(deleteStep: DeleteStepData) {
        if (this.isRecycleBin) {
            this.isRecycleBinItem = true;
            this.selectNode = deleteStep.stepId;
            this.openRecycleBinClearNodesDialog();
        } else {
            this.setSideBar = '';
            this.isRecycleBinItem = false;
            this.flowBuilderService.deleteStep(deleteStep);
            this.resetSelectedNode();
        }
        this.isNewNode = false;
        this.updateCodeView();
    }

    trackBy(index: any, step: stepLocation) {
        if (!step) {
            return null;
        }
        return step.nodeId;
    }

    nodeClick($event: NodeEmitter, isrecycleBinNode: boolean) {
        const form = this.activeFormService.getActiveForm();
        if (form && form.dirty) {
            this.resetSelectedNode();
            return;
        }
        this.isRecycleBin = isrecycleBinNode;
        this.isRecycleBinItem = isrecycleBinNode;
        if ($event.stepType === 'new') {
            return;
        }
        this.nodeClickedEvent = $event;
        this.selectedNode = $event.stepId;

        if (this.activeMode === FlowModeState.PREVIEW_MODE) {
            this.zoomService.scrollTo(this.selectedNode);
        }

        this.stepData = {
            id: $event.stepId,
            type: $event.stepType,
            nodeType: $event.nodeType,
            step: this.flowBuilderService.getFlow()[$event.stepId],
            parentId: $event.parentId,
            extraFields: $event.extraFields
        };
        this.setSideBar = 'EDIT';
        this.updateCodeView();
    }

    goToFlow(flowName: string) {
        this.router.navigate([
            'flow',
            this.sharedService.getEnvironment(),
            this.sharedService.getEntityType(),
            this.sharedService.getEntityId(),
            flowName.replace(/:.*$/, ''),
        ]);
    }

    showSubmitForApprovalDialog() {
        if (this.entityConfig && this.entityConfig['single-approver'] === true) {
            this.createConfirmConfig();
            this.viewcontainer.createComponent(ConfirmationPopupComponent);
        } else {
            if (!this.sharedService.getIsFlowChanged() && this.activeFlowPath !== '__NEW_FLOW__') {
                const dialogRef = this.dialog.open(this.submitForApprovalDialog, {
                    panelClass: 'submitForApproval',
                    width: '530px',
                    height: '280px',
                    disableClose: true,
                });

                if (dialogRef) {
                    this.flowTitle = this.sharedService.flow
                        ? this.sharedService.flow.metaData.directory
                        : find(this.sharedService.flows, (flow) => flow.metaData.flowId === this.activeFlowPath);
                }
            } else {
                swalMini({
                    title: 'Please save flow before submitting for Approval',
                    text: '',
                    type: 'warning',
                });
            }
        }
    }

    closeSubmitForApprovalDialog() {
        this.submitForApprovalMessage = '';
        this.dialog.closeAll();
    }

    submitForApproval(invalid: boolean) {
        if (!invalid) {
            const submissionRequest: SubmissionRequest = {
                summary: this.submitForApprovalMessage,
                fileName: this.sharedService.getFlowRef,
                // * might be worth it to use this.flowName as opposed to the shared service
                flowPath: this.sharedService.getFlowNameToPath.replace(',', '/'),
                entityId: this.sharedService.getEntityId(),
                entityType: this.sharedService.getEntityType().toUpperCase(),
                submissionType: 'PROMOTE',
            };

            this.submissionService
                .createSubmission(this.sharedService.getEnvironment(), submissionRequest)
                .subscribe((isSuccess) => {
                    if (isSuccess) {
                        swalMini({
                            title: 'Successfully submitted for Approval',
                            text: '',
                            type: 'success',
                        });
                    } else {
                        swalMini({
                            title: 'A Problem occurred while submitting for Approval',
                            text: '',
                            type: 'warning',
                        });
                    }
                    this.dialog.closeAll();
                    this.submitForApprovalMessage = '';
                }, (error) => {
                    const message = error?.error?.message || 'A Problem occurred while submitting for Approval';
                    swalMini({
                        title: message,
                        text: '',
                        type: 'error',
                    });
                    this.dialog.closeAll();
                    this.submitForApprovalMessage = '';
                });
        }
    }

    clearFlowArea() {
        this.router.navigate(['/']);
        this.sharedService.setFlowPathName('');
    }

    private isReloadRequired(params: Object): boolean {
        const localEnvironment: Environment = {
            entityId: params['entityId'],
            entityType: params['entityType'],
            environment: params['env'],
        };
        if (JSON.stringify(this.globalEnvironment) !== JSON.stringify(localEnvironment)) {
            this.sharedService.setEntityId(params['entityId']);
            this.sharedService.setEntityType(params['entityType']);
            this.sharedService.setEnvironment(params['env']);

            this.globalEnvironment = Object.assign({}, this.sharedService.globalEnvironment);
            return true;
        }
        return false;
    }

    canSaveFlow() {
        if (this.savingInProgress) {
            return false;
        }
        return !(this.sharedService.getIsFlowChanged() && !this.flowBuilderService.canSave());
    }

    openSettingsAndShortcutsDialog() {
        this.settingsAndShortcutsDialogRef = this.dialog.open(this.settingsAndShortcutsDialog, {
            panelClass: 'clickatellDialog',
            width: '518px',
            // height: '599px',
            disableClose: true,
        });
    }

    closeSettingsAndShortcutsDialog(): void {
        this.settingsAndShortcutsDialogRef.close();
    }


    onNode(onNodeEvent: OnEnterEvent): void {
        this.onNodeEvent = onNodeEvent;
        // if (onNodeEvent !== undefined) {
        //   this.keyEventsService.nodeKeydownSubscribe(
        //       () => { this.copyFlowCallback(); },
        //       () => { this.pasteFlowCallback(); });
        // } else {
        //   this.keyEventsService.nodeUnsubscribeKeyEventsSubscriptions();
        // }
    }


    openZoomMenu(event: MouseEvent) {
        event.preventDefault();
        this.zoomMenu.openMenu();
    }

    checkFlowIssue() {
        const flowIssue = JSON.parse(localStorage.getItem('flowIssue'));
        if (flowIssue && flowIssue.type === 'flow') {
            this.zoomService.scrollTo(flowIssue.step);
        }
        localStorage.removeItem('flowIssue');
    }

    getIsModalOpen() {
        return this.flowBuilderService.getModalOpen();
    }

    setFlowMode() {
        this.store.dispatch(flowModeAction({flowModeState: FlowModeState.FLOW_MODE}));
        this.activeMode = this.stateService.getFlowMode();
        this.setSideBar = '';
        this.setDefaultRightSidebarWidth();
        this.zoomService.resetZoom();
        this.logsOpen = false;
    }

    setDefaultRightSidebarWidth() {
        const rightSidebar = document.querySelector('#right-sidebar-parent') as HTMLDivElement;
        if (rightSidebar) {
            rightSidebar.style.width = '360px';
        }
    }

    // isPreviewMode() {
    //   return this.activeMode === FlowModeState.PREVIEW_MODE;
    // }

    toggleLogs(status) {
        if (status === 'open') {
            this.openLogs();
        }
        if (status === 'close') {
            this.closeLogs();
        }
    }

    openLogs() {
        this.logsOpen = true;
        this.setCenterOnCanvas('logsDrawer', 'drawArea', 4, 2);
    }

    closeLogs() {
        this.logsOpen = false;
        this.setCenterOnCanvas('dragArea', 'drawArea', 2, 2);
    }

    checkSingleApprover() {
        if (this.entityConfig &&
            this.entityConfig['single-approver'] === true) {
            return 'Deploy to Production';
        }
        return 'Submit for Approval';
    }

    updateFlow(flowName) {
        this.reset();
        this.loadFlow(this.sharedService.getEnvironment(), this.sharedService.getEntityId(), flowName);
    }

    setCenterOnCanvas(elementToObserve: string, elementToResize: string, heightDiv: number, widthDiv: number) {
        setTimeout(() => {
            const observeElement = document.getElementById(elementToObserve);
            if (!observeElement) return;

            const observer = new ResizeObserver(entries => {
                const element: HTMLElement = document.getElementById(elementToResize);
                if (!element) return;

                if (this.activeMode === FlowModeState.PREVIEW_MODE) {
                    for (const entry of entries) {
                        this.areaWidth = entry.contentRect.width;
                        this.areaHeight = entry.contentRect.height;
                        if (this.areaWidth > 0 && this.areaHeight > 0) {
                            element.style.translate = `${this.areaWidth / widthDiv}px ${this.areaHeight / heightDiv}px`;
                        }
                    }
                } else {
                    element.style.translate = '0px 0px';
                }
            });
            observer.observe(observeElement);
            this.resizeObservers.push(observer);
        }, 1);
    }

    searchBarDisplay() {
        if (this.currentFlowSteps?.length > 0 && this.activeMode !== 'SEARCH_MODE') {
            this.activeMode = FlowModeState.SEARCH_MODE;
            this.store.dispatch(flowModeAction({flowModeState: FlowModeState.SEARCH_MODE}));
        }
    }

    closeSearch() {
        this.activeMode = FlowModeState.FLOW_MODE;
        this.store.dispatch(flowModeAction({flowModeState: FlowModeState.FLOW_MODE}));
    }

    searchItemClicked(clickEvent: MatchClickEvent): void {
        if (!clickEvent) {
            this.setSideBar = '';
            this.highLightAndScrollTo = undefined;
            this.selectedNode = undefined;
            return;
        }
        const {stepId, stepType, nodeType, matched, found} = clickEvent;

        if (this.selectedNode !== stepId) {

            const node = new NodeEmitter(stepId, stepType, nodeType, 'parentId', {});
            this.nodeClick(node, false);
            this.zoomService.scrollTo(stepId);

            if (this.highLightAndScrollTo) {
                this.highLightAndScrollTo.destroy();
            }

            if (!matched) {
                this.highLightAndScrollTo = undefined;
                return;
            }

            this.highLightAndScrollTo = new HighLightAndScrollTo(found, matched);
            return;
        }

        if (this.highLightAndScrollTo) {
            this.highLightAndScrollTo.scrollToElement(matched);
        } else {
            this.highLightAndScrollTo = new HighLightAndScrollTo(found, matched);
        }
    }

    onReplace(event: ReplaceStep): void {
        const {stepId, step, stepType, nodeType} = event;
        this.flowBuilderService.addStep(stepId, step);
        if (this.selectedNode === event.stepId) {
            const node = new NodeEmitter(stepId, stepType, nodeType, 'parentId', {});
            this.nodeClick(node, false);
        }
        this.sharedService.setIsFlowChanged(true);
    }

    onReplaceAll(steps: ReplaceAllSteps[]): void {
        if (this.selectedNode) {
            this.resetSelectedNode('reset');
        }
        steps.forEach(step => this.flowBuilderService.addStep(step.stepId, step.step));
        this.sharedService.setIsFlowChanged(true);
    }

    openFlowSummaryDialog(): void {
        this.isFlowSummarySidebarVisible = true;
    }

    closeFlowSummarySidebar(): void {
        this.isFlowSummarySidebarVisible = false;
    }

  toggleView(event: Event): void {
    const checkbox = event.target as HTMLInputElement;
    const isTogglingToCodeView = checkbox.checked;

    if (isTogglingToCodeView) {
      this.showCodeView = true;
      this.codeText = JSON.stringify(this.flowBuilderService.getFlow(), null, 2);
      this.originalCodeText = this.codeText;
      this.isCodeModified = false;
    } else {
      // Trying to untoggle from code view to visual view
      if (!this.validateJsonBeforeSwitch()) {
        // Invalid JSON - prevent toggle and keep in code view
        checkbox.checked = true;
        return;
      }
      this.showCodeView = false;
      this.setArea();
      if (!this.isCodeModified) {
        this.flowBuilderService.resetFlow();
        this.flowBuilderService.buildFlow(
          JSON.parse(this.codeText),
          this.sharedService.getFlowStatus
        );
      }
    }
  }

    private updateCodeView(): void {
        this.codeText = JSON.stringify(this.flowBuilderService.getFlow(), null, 2);
        this.originalCodeText = this.codeText;
        this.isCodeModified = false;
    }

  private validateJsonBeforeSwitch(): boolean {
    try {
      JSON.parse(this.codeText);
      return true;
    } catch (error: any) {
      let errorMessage = 'We couldn\'t parse your JSON.';
      const match = /position (\d+)/i.exec(error.message);
      if (match) {
        const pos = parseInt(match[1], 10);
        const line = this.codeText.slice(0, pos).split('\n').length;
        errorMessage += ` Error at line ${line}: ${error.message}`;
      } else {
        errorMessage += ` ${error.message}`;
      }
      this.showAlert('Invalid JSON', errorMessage);
      return false;
    }
  }

  applyCodeChanges$(): Observable<void> {
    const loadPermissions$ = combineLatest([
      this.store.pipe(select(selectMenuNodeTypes), take(1)),
      this.store.pipe(select(selectActionNodeTypes), take(1)),
      this.store.pipe(select(selectIntegrationsNodeTypes), take(1)),
      this.store.pipe(select(selectChatHubNodesTypes), take(1)),
      this.store.pipe(select(selectNodeTypes), take(1))
    ]).pipe(
      tap(([menuNodes, actionNodes, integrationNodes, chatHubNodes, nodeTypes]) => {
        this.permittedMenu = menuNodes.map(n => n.nodeType);
        this.permittedAction = actionNodes.map(n => n.nodeType);
        this.permittedChatHub = chatHubNodes.map(n => n.nodeType);
        const integrationsMap = integrationNodes as unknown as Record<string, NodeObject[]>;
        this.permittedIntegration = Object
          .values(integrationsMap)
          .flat()
          .map(n => n.nodeType)
          .concat('endNode');
        this.permittedNodes = Object.values(nodeTypes)
          .flat()
          .map(n => n.nodeType);
      })
    );
    const build$ = of(null).pipe(
      tap(() => this._tryBuildFromCodeText()),
      catchError(err => throwError(() => err))
    );
    return (this.permittedMenu.length === 0
        ? loadPermissions$.pipe(switchMap(() => build$))
        : build$
    );
  }

    private _tryBuildFromCodeText(): void {
        try {
            const parsedFlow = JSON.parse(this.codeText);
            const typeErrors = this.validateNodeTypes(
                parsedFlow,
                this.permittedMenu,
                this.permittedAction,
                this.permittedIntegration,
                this.permittedChatHub,
                this.permittedNodes
            );
            if (typeErrors.length > 0 && (this.permittedMenu.length > 0 || this.permittedAction.length > 0 || this.permittedIntegration.length > 0)) {
                this.showAlert(
                    'Access Denied',
                    `You don’t have permission to use these node types:\n• ${typeErrors.join('\n• ')}`
                );
                return;
            }
            const validationErrors = this.validateFlow(parsedFlow);
            if (validationErrors.length > 0) {
                this.showAlert(
                    'Validation Errors Found',
                    `Please correct the following before rebuilding:\n• ${validationErrors.join('\n• ')}`
                );
                return;
            }
            if (this._hasApiPlaceholder(parsedFlow)) {
                this.showAlert(
                    'API Integration Needed',
                    'This template refers to an API placeholder. Don’t forget to select your API before running.'
                );
                return;
            }
            this.flowBuilderService.resetFlow();
            this.flowBuilderService.buildFlow(parsedFlow, this.sharedService.getFlowStatus);
            this.sharedService.setIsFlowChanged(true);
        } catch (error: any) {
            let errorMessage = 'We couldn’t parse your JSON.';
            const match = /position (\d+)/i.exec(error.message);
            if (match) {
                const pos = parseInt(match[1], 10);
                const line = this.codeText.slice(0, pos).split('\n').length;
                errorMessage += ` Error at line ${line}: ${error.message}`;
            } else {
                errorMessage += ` ${error.message}`;
            }
            this.showAlert(
                'Invalid JSON',
                errorMessage
            );
        }
    }

    private _hasApiPlaceholder(flow: any): boolean {
        for (const stepKey in flow) {
            if (flow.hasOwnProperty(stepKey)) {
                const step = flow[stepKey];
                if (
                    step.type === 'action' &&
                    step.action &&
                    step.action.actionParams.apiName === 'PLACEHOLDER'
                ) {
                    return true;
                }
            }
        }
        return false;
    }

    private validateFlow(flow: any): string[] {
        const errors: string[] = [];
        for (const stepKey in flow) {
            if (flow.hasOwnProperty(stepKey)) {
                const step = flow[stepKey];
                if (!step.hasOwnProperty('type')) {
                    errors.push(`Step "${stepKey}" is missing the "type" property.`);
                }
            }
        }

        const checkNextProperty = (obj: any, path: string) => {
            if (Array.isArray(obj)) {
                obj.forEach((item, index) => {
                    checkNextProperty(item, `${path}[${index}]`);
                });
            } else if (obj && typeof obj === 'object') {
                for (const key in obj) {
                    if (!obj.hasOwnProperty(key)) {
                        continue;
                    }
                    if (key === 'next' && typeof obj[key] === 'string') {
                        const allowedNextValues = ['NextStep', '_MENU_END_', 'OPTIONAL'];
                        if (!allowedNextValues.includes(obj[key]) && !flow.hasOwnProperty(obj[key])) {
                            errors.push(`Hanging step detected at "${path}": "next" references non-existing step "${obj[key]}".`);
                        }
                    } else {
                        checkNextProperty(obj[key], path + '.' + key);
                    }
                }
            }
        };

        // for (const stepKey in flow) {
        //     if (flow.hasOwnProperty(stepKey)) {
        //         checkNextProperty(flow[stepKey], stepKey);
        //     }
        // }

        return errors;
    }

    private validateNodeTypes(
        flow: any,
        permittedMenu: string[],
        permittedAction: string[],
        permittedIntegration: string[],
        permittedChatHub: string[],
        permittedNodes: string[]
    ): string[] {
        const errors: string[] = [];
        for (const key of Object.keys(flow)) {
            if (key === 'start') {
                continue;
            }
            const step = flow[key];
            let nodeType: string | undefined;
            let isPermitted = false;
            switch (step.type) {
                case 'menu':
                    nodeType = step.menu?.menuType;
                    if (!nodeType) {
                        errors.push(`"${key}": missing menu.menuType`);
                        continue;
                    }
                    if (!permittedMenu.includes(nodeType)) {
                        errors.push(`"${key}": Menu "${nodeType}" not permitted`);
                    } else {
                        isPermitted = true;
                    }
                    break;
                case 'action':
                    nodeType = step.action?.actionType;
                    if (!nodeType) {
                        errors.push(`"${key}": missing action.actionType`);
                        continue;
                    }
                    if (!permittedAction.includes(nodeType)) {
                        errors.push(`"${key}": Action "${nodeType}" not permitted`);
                    } else {
                        isPermitted = true;
                    }
                    break;
                case 'integration':
                    nodeType = step.integration?.integrationType;
                    if (!nodeType) {
                        errors.push(`"${key}": missing integration.integrationType`);
                        continue;
                    }
                    if (!permittedIntegration.includes(nodeType)) {
                        errors.push(`"${key}": Integration "${nodeType}" not permitted`);
                    } else {
                        isPermitted = true;
                    }
                    break;
                case 'chatHub':
                    nodeType = step.action?.actionType;
                    if (!nodeType) {
                        errors.push(`"${key}": missing action.actionType for chatHub`);
                        continue;
                    }
                    if (!permittedChatHub.includes(nodeType)) {
                        errors.push(`"${key}": ChatHub "${nodeType}" not permitted`);
                    } else {
                        isPermitted = true;
                    }
                    break;
                default:
                    errors.push(`"${key}": Unrecognized step type "${step.type}"`);
                    continue;
            }
            if (!isPermitted && nodeType && !permittedNodes.includes(nodeType)) {
                errors.push(`"${key}": Node type "${nodeType}" not in selectable nodeTypes list`);
            }
        }
        return errors;
    }

    openTemplateModal() {
        this._flowBeforeTemplate = cloneDeep(this.flowBuilderService.getFlow());
        this.pendingSelection = this.sharedService.getFlowRef;
        this.pendingSelectionStep = this.selectedNode || '';
        this.flowBuilderService.setModalOpen(true);
        this.showTemplateModal = true;
        this.templateMode = true;
    }

    private extractAssetRefs(flow: any): string[] {
        const refs = new Set<string>();
        const traverse = (obj: any) => {
            if (Array.isArray(obj)) {
                obj.forEach(traverse);
            } else if (obj && typeof obj === 'object') {
                for (const [key, val] of Object.entries(obj)) {
                    if ((key === 'imageRef' || key === 'varName') && typeof val === 'string' && val.trim().length > 0) {
                        refs.add(val);
                    } else {
                        traverse(val);
                    }
                }
            }
        };
        traverse(flow);
        return Array.from(refs);
    }

    private clearAssetRefs(obj: any): void {
        if (Array.isArray(obj)) {
            obj.forEach(o => this.clearAssetRefs(o));
        } else if (obj && typeof obj === 'object') {
            for (const [key, val] of Object.entries(obj)) {
                if ((key === 'imageRef' || key === 'varName') && typeof val === 'string') {
                    obj[key] = '';
                } else {
                    this.clearAssetRefs(val);
                }
            }
        }
    }

    private ensureFlowBuilderState(): void {
        this.flowBuilderService.setModalOpen(false);
        this.showTemplateModal = false;
        this.templateMode = false;
        this.sharedService.clearPendingFlowType();
        setTimeout(() => {
            this.flowBuilderService.setModalOpen(false);
            this.showTemplateModal = false;
        }, 0);
    }

    onFlowStepSelectionClose(data: { selection: string, copyAssets: boolean }) {
        const {selection, copyAssets} = data;
        if (selection) {
            this.isImportingTemplate = true;
        }
        this.flowBuilderService.setModalOpen(false);
        this.showTemplateModal = false;
        this.templateMode = false;
        this.ensureFlowBuilderState();
        if (!selection) {
            this.router.navigate([], {
                queryParams: {openTemplate: null},
                queryParamsHandling: 'merge',
                replaceUrl: true
            });

            return;
        }

        const [flowId, stepId] = selection.split(':');
        if (!copyAssets) {
            return this.closeTemplateWithoutAssets(flowId, stepId, false);
        }
        const flow = this.flowBuilderService.getFlow();
        const assetRefs = this.extractAssetRefs(flow);
        if (assetRefs.length === 0) {
            return this.closeTemplateWithoutAssets(flowId, stepId, false);
        }
        const entityType = this.sharedService.getEntityType().toUpperCase();
        const entityId = +this.sharedService.getEntityId();
        this.flowManagerService.lookupAssetReferences(assetRefs).pipe(
            switchMap((lookupResult: { [key: string]: any }) => {
                const existingRefs = Object.keys(lookupResult);
                if (existingRefs.length === 0) {
                    return of({noAssetsFound: true, results: []});
                }
                const calls = existingRefs.map(ref => {
                    const req: MediaCopyRequest = {reference: ref};
                    const endpoint = `/copy/${entityType}/${entityId}`;
                    console.log(`[Asset Copy] POST ${endpoint}`, req);
                    return this.flowManagerService
                        .copyAssets(entityType, entityId.toString(), req)
                        .pipe(
                            tap(response => {
                                console.log(`[Asset Copy] Response:`, response);
                            }),
                            catchError(err => {
                                swalMini({title: `Unable to copy asset`, text: err.message, type: 'warning'});
                                return of(null as MediaCopyResponse);
                            })
                        );
                });
                return forkJoin(calls).pipe(map(results => ({noAssetsFound: false, results})));
            }),
            finalize(() => this.closeTemplateWithoutAssets(flowId, stepId, true))
        ).subscribe(response => {
            if (response.noAssetsFound) {
                swalMini({
                    title: 'No assets found to copy',
                    text: 'Asset references exist in the flow but no corresponding assets were found in the library.',
                    type: 'info'
                });
            } else {
                const results = response.results;
                const successCount = results.filter(r => r?.transferStatus === 'COMPLETE').length;
                const failedCount = results.filter(r => r?.transferStatus === 'TRANSFER_FAILED').length;
                const totalFound = results.length;
                if (failedCount > 0) {
                    swalMini({
                        title: `${successCount} of ${totalFound} assets copied!`,
                        text: `${failedCount} asset(s) failed to copy.`,
                        type: failedCount === totalFound ? 'error' : 'warning'
                    });
                } else {
                    swalMini({
                        title: `${successCount} of ${totalFound} assets copied!`,
                        type: 'success'
                    });
                }
            }
        });
    }

    private closeTemplateWithoutAssets(flowId: string, stepId?: string, copyAssets: boolean = false) {
        if (stepId) {
            this.flowManagerService.getFlow(flowId).pipe(take(1)).subscribe(flow => {
                if (!copyAssets) {
                    this.clearAssetRefs(flow);
                }
                this.flowBuilderService.buildFlow(flow);
                this.sharedService.setFlowRef = flowId;
                this.zoomService.resetZoom();
                this.zoomService.setZoom(100);
                this.zoomService.scrollTo(stepId);
            });
        } else if (flowId) {
            this.importSystemFlow(flowId, copyAssets);
        }
    }

  private importSystemFlow(flowId: string, copyAssets: boolean) {
    this.isImportingTemplate = true;
    this.flowBuilderService.setModalOpen(false);
    this.showTemplateModal = false;
    this.flowWebSocket.unLockFlow();
    this.sharedService.setIsFlowChanged(true);
    this.sharedService.setFlowRef  = flowId;
    this.sharedService.setFlowName = flowId;
    this.sharedService.setFlowPathName(this.sharedService.getNewFlowName());

        this.flowBuilderService.resetFlow();
        const oldFlow = {};

    this.flowManagerService.getSystemFlow(flowId).pipe(
      map(template => this.mergeFlowUniqueIDs(template, oldFlow)),
      map(flow => {
        const existingIDs = new Set(
          Object.values(oldFlow).map((s: any) => s.metadata?.stepUniqueID)
        );
        for (const key of Object.keys(flow)) {
          if (flow[key].metadata?.stepUniqueID
            && existingIDs.has(flow[key].metadata.stepUniqueID)
          ) {
            delete flow[key];
          }
        }
        return flow;
      }),
      map(flow => this.removeMetadata(flow)),
      map(flow => {
        if (this.permittedMenu.length > 0 || this.permittedAction.length > 0 || this.permittedIntegration.length > 0) {
          const errs = this.validateNodeTypes(
            flow,
            this.permittedMenu,
            this.permittedAction,
            this.permittedIntegration,
            this.permittedChatHub,
            this.permittedNodes
          );
          if (errs.length) {
            errs.forEach(err => {
              const m = /^"([^"]+)"/.exec(err);
              if (m) { delete flow[m[1]]; }
            });
          }
        }
        return flow;
      })
    ).subscribe(
      patchedFlow => {
        if (!copyAssets) {
          this.clearAssetRefs(patchedFlow);
        }
        this.codeText = JSON.stringify(patchedFlow, null, 2);
        this.setArea();
        this.applyCodeChanges$().subscribe({
          next: () => {
            this.flow = JSON.parse(this.codeText);
            this.zoomService.resetZoom();
            this.zoomService.setZoom(100);
            setTimeout(() => {
              this.isImportingTemplate = false;
            }, 100);
          },
          error: err => {
            alert(`Error loading template: ${err.message || 'Unknown validation error'}`);
            this.sharedService.setIsFlowChanged(false);
            this.isImportingTemplate = false;
          }
        });
      },
      err => {
        alert(`Error importing template: ${err.message || err}`);
        this.sharedService.setIsFlowChanged(false);
        this.isImportingTemplate = false;
      }
    );
  }

    private removeMetadata(obj: any): any {
        if (Array.isArray(obj)) {
            return obj.map(item => this.removeMetadata(item));
        } else if (obj !== null && typeof obj === 'object') {
            const newObj: any = {};
            Object.keys(obj).forEach(key => {
                if (!key.toLowerCase().includes('metadata')) {
                    newObj[key] = this.removeMetadata(obj[key]);
                }
            });
            return newObj;
        }
        return obj;
    }

    private mergeFlowUniqueIDs(newFlow: any, oldFlow: any): any {
        newFlow = this.removeMetadata(newFlow);
        for (const stepId in newFlow) {
            if (
                oldFlow?.[stepId]?.metadata?.stepUniqueID
            ) {
                newFlow[stepId].metadata = {
                    stepUniqueID: oldFlow[stepId].metadata.stepUniqueID
                };
            }
        }
        return newFlow;
    }

    public tryBuild = (flow: any) => {
        this.codeText = JSON.stringify(flow, null, 2);
        this.applyCodeChanges$().subscribe();
    }

    showAlert(title: string, text?: string): MatDialogRef<any> {
        this.alertTitle = title;
        this.alertText = text || '';
        return this.dialog.open(this.alertDialog, {
            panelClass: 'saveNewFlowDialog',
            width: '430px',
            maxHeight: '80vh',
            disableClose: true,
        });
    }

    closeAlert() {
        this.dialog.closeAll();
    }

    public applyCodeChangesHandler(): void {
        this.applyCodeChanges$()
            .subscribe({
                    next: () => {
                        this.originalCodeText = this.codeText;
                        this.isCodeModified = false;
                    },
                    error: err => {
                        this.showAlert(
                            'Build Failed',
                            err?.message
                                ? `Sorry, we couldn’t apply your changes:\n${err.message}`
                                : 'An unexpected error occurred while rebuilding your flow. Please try again.'
                        );
                    }
                }
            );
    }

    public onCodeChange(): void {
        this.isCodeModified = this.codeText !== this.originalCodeText;
    }
}
